import * as React from 'react'
import styled from 'styled-components'
import { config } from 'react-awesome-styled-grid'
import { playAudio } from '../../actions/audioActions'
import { useDispatch } from 'react-redux'
import type { TrackPropsType } from '../../models/Track'
import PlayIcon from '@components/shared/icons/PlayIcon'
import { CTAPrimaryOrange } from '@components/shared'
import { events } from '../../services/analytics'

type PropsType = TrackPropsType & {
  size?: number,
  isIconStyle?: boolean
}

const TriangleIcon = (): React.ReactNode => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M2.63119 0.833655C1.96461 0.460356 1.14258 0.942163 1.14258 1.70615V14.2237C1.14258 15.0032 1.99482 15.483 2.66125 15.0787L13.3906 8.56979C14.0455 8.17249 14.0289 7.21658 13.3605 6.84231L2.63119 0.833655Z'
      fill='white'
    />
  </svg>
)

export function PlayButtonComponent (props: {
  size?: number,
  playTrackAudio: () => void,
  isIconStyle: boolean
}): React.ReactNode {
  if (props.isIconStyle) {
    return (
      <PlayButtonIconContainer>
        <PlayButtonContainer
          $width={props.size}
          $height={props.size}
          onClick={props.playTrackAudio}
        >
          <PlayIcon size={props.size} />
        </PlayButtonContainer>
      </PlayButtonIconContainer>
    )
  }

  return (
    <>
      <XSPlayButtonContainer>
        <PlayButtonContainer
          $width={props.size}
          $height={props.size}
          onClick={props.playTrackAudio}
        >
          <PlayIcon size={props.size} />
        </PlayButtonContainer>
      </XSPlayButtonContainer>
      <CTAPlayContainer>
        <LargePlayButton onClick={props.playTrackAudio}>
          <span><TriangleIcon /></span>
          PLAY
        </LargePlayButton>
      </CTAPlayContainer>
    </>
  )
}

export function PlayButton (props: PropsType): React.ReactNode {
  const dispatch = useDispatch()

  const playTrackAudio = (): void => {
    if (props.audioUrl) {
      const description = props.series?.[0]
        ? (props.series[0].episodeInfo || '') + ' ' + props.series[0].title
        : ''
      dispatch(
        playAudio({
          id: props.id,
          title: props.title,
          description,
          imageUrl: props.images.img500,
          slug: props.slug,
          audioUrl: props.audioUrl,
          duration: props.duration
        })
      )
      events.track_started(props.id)
    }
  }

  return (
    <PlayButtonComponent
      size={props.size}
      playTrackAudio={playTrackAudio}
      isIconStyle={!!props.isIconStyle}
    />
  )
}

const LargePlayButton = styled(CTAPrimaryOrange)<any>`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Good Sans Regular';
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 100%;
  letter-spacing: 0.3px;
  text-transform: uppercase;
  min-width: 400px;
  padding: 0 16px;
  ${(props: any): any => config(props).media.md`
      font-size: 14px;
    `}
  span {
    margin-right: 8px;
  }
`

const XSPlayButtonContainer = styled.div<any>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 60px;
  ${(props: any): any => config(props).media.sm`
    display: none;
  `}
`

const PlayButtonContainer = styled.div<any>`
  /* default sizes */
  width: 33px;
  height: 33px;
  ${(props: any): any => config(props).media.md`
  width: 45px;
  height: 45px;
  `}
  ${(props: any): any => config(props).media.lg`
  width: 60px;
  height: 60px;
  `}

  width: ${(props: any): number => props.$width}px;
  height: ${(props: any): number => props.$height}px;
`

const CTAPlayContainer = styled.div<any>`
  display: none;
  ${(props: any): any => config(props).media.sm`
    display: flex;
  `}
`

const PlayButtonIconContainer = styled.div<any>`
  position: relative;
`
